// src/auth/registerApi.js

const getUser = async (token) => {
  try {
    const response = await fetch("https://campus.acetians.in/api/v3/user", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    return data.user;
  } catch (error) {
    console.error("Registration error:", error);
    throw error;
  }
};

export default getUser;
